import React from 'react'

const loading = () => {
    return (
        <div>
            <div className="preloader">
                <div className="loader-ripple">
                    <div />
                    <div />
                </div>
            </div>
        </div>
    )
}

export default loading
